import HerbIcon from "@gaiaherbs/Icons/HerbIcon";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Hidden from "@insite/mobius/Hidden";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasHistory;

export interface GAIAMeetYourHerbsBtnStyles {
    btn?: ButtonPresentationProps;
}

export const buttonStyles: GAIAMeetYourHerbsBtnStyles = {
    btn: {
        icon: {
            src: HerbIcon,
            position: "left",
        },
        sizeVariant: "small",
        color: "#93C90E",
        typographyProps: {
            color: "primary",
            size: 15,
        },
        css: css`
            margin: 4px 0 3px;
        `,
    },
};

const styles = buttonStyles;

const GAIAHeaderMeetYourHerbsButton: FC<Props> = ({ id, history }) => {
    return (
        <Button onClick={() => history.push("/AboutUs/MeetYourHerbs")} {...styles.btn}>
            Meet Your Herbs
        </Button>
    );
};

const widgetModule: WidgetModule = {
    component: withHistory(GAIAHeaderMeetYourHerbsButton),
    definition: {
        group: "Common",
        displayName: "GAIA Header Meet Your Herb",
        icon: "link-simple",
    },
};

export default widgetModule;
